// @ts-nocheck converted from existing component
// If making changes look to fix and remove this

import React from "react"
import Notification from "@components/Notification/Notification"
import { useContentJsx } from "@/utils/hooks/useContent"
import { useMemberDetails } from "@/utils/hooks/useMember"

function EmailEndingNotice() {
  const { contentBody, valOne: emails } = useContentJsx(
    "dashboard_notifications.email_address_ending"
  )

  const { isFetching, isError, memberData, userData } = useMemberDetails()

  // both apis are critical so the app will likely error out elsewhere
  // No need to error out or show loader here
  if (isFetching || isError) return null

  const linkEmail = memberData?.member?.emailAddress
  const oktaEmail = userData?.profile?.email
  const emailList = emails.split(/\r?\n/)

  const showNotice = [linkEmail, oktaEmail].some((email) =>
    email ? emailList.includes(email.split("@")[1]) : false
  )

  if (showNotice) {
    return (
      <Notification closeButton={true} notificationType={"alert"}>
        {contentBody}
      </Notification>
    )
  }

  return null
}

export default EmailEndingNotice
